<template>
  <div>
    <scorder :order_type="0" > </scorder> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import scorder from '../../tongyong/scorder.vue'
 
export default {

  components: {
    scorder: scorder 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
